import { REQUEST_VIEW_OPTIONS, type RequestViewFilter } from "./constants";
import InfoTooltip from "../../ui/InfoTooltip/InfoTooltip";

type TeenRequestedGigsFiltersProps = {
  selectedFilter: RequestViewFilter;
  search: string;
  totalRequests: number;
  activeRequests: number;
  awaitingConfirmationRequests: number;
  closedRequests: number;
  withdrawnRequests: number;
  onFilterChange: (filter: RequestViewFilter) => void;
  onSearchChange: (value: string) => void;
};

const TeenRequestedGigsFilters = ({
  selectedFilter,
  search,
  totalRequests,
  activeRequests,
  awaitingConfirmationRequests,
  closedRequests,
  withdrawnRequests,
  onFilterChange,
  onSearchChange,
}: TeenRequestedGigsFiltersProps) => {
  const countsByFilter: Record<RequestViewFilter, number> = {
    ACTIVE: activeRequests,
    AWAITING_CONFIRMATION: awaitingConfirmationRequests,
    PAST: closedRequests + withdrawnRequests,
    ALL: totalRequests,
  };

  return (
    <section className="mt-6 rounded-[1.75rem] border border-myteengig-border bg-white p-4 shadow-sm sm:p-5">
      <div className="grid gap-4 lg:grid-cols-[minmax(16rem,1fr)_auto] lg:items-end">
        <div>
          <label htmlFor="teen-request-filter-search" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted">
            Search
          </label>
          <input
            id="teen-request-filter-search"
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Gig title or category"
            className="w-full rounded-lg border border-myteengig-border bg-white px-4 py-3 text-base text-myteengig-text-primary shadow-sm outline-none transition focus:border-myteengig-primary focus:ring-2 focus:ring-myteengig-primary/20"
          />
        </div>

        <div className="min-w-0 flex flex-col gap-3 sm:flex-row sm:flex-wrap lg:justify-end">
          {REQUEST_VIEW_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`min-w-0 w-full rounded-2xl border px-3 py-3 text-sm font-semibold transition-colors sm:w-auto sm:rounded-full sm:px-4 sm:py-2 ${
                selectedFilter === option.value
                  ? "border-myteengig-primary bg-myteengig-primary text-white"
                  : "border-myteengig-border bg-white text-myteengig-text-primary hover:border-myteengig-primary hover:text-myteengig-primary"
              }`}
              onClick={() => onFilterChange(option.value)}
            >
              <span className="flex min-w-0 w-full items-center justify-between gap-2 text-left sm:inline-flex sm:w-auto sm:justify-start sm:gap-3">
                <span className="flex min-w-0 flex-1 items-center gap-1.5 sm:flex-initial sm:gap-2">
                  <span className="break-words text-[13px] leading-5 sm:text-sm">{option.label}</span>
                  <span className="shrink-0">
                    <InfoTooltip
                      label={`${option.label} filter info`}
                      placement="top-center"
                      message={option.description}
                    />
                  </span>
                </span>
                <span
                  className={`inline-flex min-w-7 shrink-0 items-center justify-center rounded-full px-2 py-0.5 text-xs font-bold ${
                    selectedFilter === option.value
                      ? "bg-white/20 text-white"
                      : "bg-myteengig-background text-myteengig-text-primary"
                  }`}
                >
                  {countsByFilter[option.value]}
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeenRequestedGigsFilters;
